import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { motion } from 'framer-motion';
import { Calendar, Plus, Trash2, GripVertical } from 'lucide-react';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const WeekScheduleEditor = ({
  program, availableWorkouts,
  onAddWeek, onRemoveWeek, onUpdateWeek,
  onToggleRestDay, onAssignWorkoutToDay,
}) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.1 }}
    className="bg-card border border-border p-6"
  >
    <div className="flex items-center justify-between mb-6">
      <h2 className="font-heading text-2xl text-white uppercase tracking-wider">
        <Calendar className="inline h-5 w-5 mr-2 text-primary" />
        Weekly Schedule ({program.weeks?.length || 0} Weeks)
      </h2>
      <Button onClick={onAddWeek} variant="outline" className="border-primary text-primary hover:bg-primary/10" data-testid="add-week-btn">
        <Plus className="h-4 w-4 mr-2" /> Add Week
      </Button>
    </div>

    <div className="space-y-6">
      {program.weeks?.map((week, weekIndex) => (
        <div key={weekIndex} className="bg-black border border-border p-4">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <GripVertical className="h-5 w-5 text-muted-foreground" />
              <span className="font-heading text-primary uppercase">Week {week.week}</span>
            </div>
            <Button variant="ghost" size="sm" onClick={() => onRemoveWeek(weekIndex)} className="text-red-400 hover:text-red-300 hover:bg-red-500/10">
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>

          <div className="mb-4">
            <Label className="text-muted-foreground text-xs uppercase">Focus</Label>
            <Input
              value={week.focus}
              onChange={(e) => onUpdateWeek(weekIndex, 'focus', e.target.value)}
              className="mt-1 bg-card border-border text-white text-sm"
            />
          </div>

          <Label className="text-muted-foreground text-xs uppercase mb-2 block">Daily Workouts</Label>
          <div className="space-y-2">
            {DAYS.map((day, dayIndex) => {
              const isRest = week.rest_days?.includes(dayIndex);
              const assignedId = week.days?.[dayIndex] || '';

              return (
                <div key={`w${weekIndex}-d${dayIndex}`} className={`flex items-center gap-3 p-2 border border-border rounded ${isRest ? 'bg-muted-foreground/5' : 'bg-card'}`}>
                  <span className={`font-heading text-xs uppercase w-10 ${isRest ? 'text-muted-foreground' : 'text-primary'}`}>{day}</span>

                  {isRest ? (
                    <span className="flex-1 text-muted-foreground text-sm italic">Rest Day</span>
                  ) : (
                    <select
                      value={assignedId}
                      onChange={(e) => onAssignWorkoutToDay(weekIndex, dayIndex, e.target.value)}
                      className="flex-1 bg-black text-white text-sm px-2 py-1.5 border border-border rounded focus:outline-none focus:border-primary"
                    >
                      <option value="" className="bg-black">-- Select Workout --</option>
                      {availableWorkouts.map((w) => (
                        <option key={w.id} value={w.id} className="bg-black">
                          {w.title} ({w.category})
                        </option>
                      ))}
                    </select>
                  )}

                  <button
                    onClick={() => onToggleRestDay(weekIndex, dayIndex)}
                    className={`text-xs px-2 py-1 rounded font-heading uppercase ${
                      isRest ? 'bg-primary/20 text-primary hover:bg-primary/30' : 'bg-muted-foreground/20 text-muted-foreground hover:bg-muted-foreground/30'
                    }`}
                    title={isRest ? 'Set as workout day' : 'Set as rest day'}
                  >
                    {isRest ? 'Activate' : 'Rest'}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  </motion.div>
);
